import React from "react";
import styled, { css } from "styled-components";
import { pageGutterSpace } from "../../../settings";
import getBorderColor from "../../../utils/getBorderColor";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import { StyledButtonAtm } from "../../atoms/ButtonAtm";
import RegularPriceMol from "../RegularPriceMol/RegularPriceMol";
import Button from "./Button";
var Container = styled.div.withConfig({
  componentId: "sc-17676v9-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;align-items:center;justify-content:space-between;padding:", ";border-top:", " solid ", ";background-color:", ";box-shadow:", ";", "{margin-left:", ";}"], space(pageGutterSpace), unit(2), getBorderColor(theme, "backgroundLight", "low"), getColor(theme, "backgroundLight"), getBoxShadow(theme, "small", true), StyledButtonAtm, space(4));
});
function ProductSummarySimpleMol(_ref2) {
  var price = _ref2.price,
    button = _ref2.button;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(RegularPriceMol, {
    integer: price.integer,
    fraction: price.fraction,
    currency: price.currency,
    suffix: price.suffix,
    isSmall: true,
    isVertical: true,
    hasTextColor: true
  }), button);
}
ProductSummarySimpleMol.Button = Button;
export default ProductSummarySimpleMol;